import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageBanner from "../components/PageBanner";
import QuoteBand from "../components/QuoteBand";
import Reveal from "../components/Reveal";
import SectionHeading from "../components/SectionHeading";
import CountUp from "../components/CountUp";
import { stats, applications } from "../mock";

const principles = [
  "20 yıllık tecrübenin yorumlandığı yer İLKA,",
  "İçerisinde çelik barındıran her projede var olmanın hedef politikası haline getirdiğimiz yer İLKA,",
  "Kalite anlayışı ve güven olgusu ile çeliğin hayat bulduğu yer İLKA,",
  "Zaman kavramının anlam kazandığı yer İLKA,",
  "Emeğin karşılığı olan yer İLKA."
];

export default function About() {
  return (
    <div className="bg-white" data-testid="about-page">
      <PageBanner
        title="Hakkımızda"
        subtitle="20 yıllık tecrübenin yorumlandığı yer İLKA."
        breadcrumbs={[{ label: "Kurumsal" }, { label: "Hakkımızda" }]}
        image="/images/slider/slider.jpg"
      />

      <section className="py-24 md:py-32 lg:py-40">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 lg:gap-20 items-center">
          <Reveal className="lg:col-span-6">
            <div className="relative">
              <div className="frame">
                <img src="/images/misc/hakkimizda.jpg" alt="Hakkımızda" className="w-full h-[440px] lg:h-[540px] object-cover" />
              </div>
              <div className="absolute -bottom-8 -right-4 md:-right-8 bg-brand-accent text-white px-7 py-6">
                <div className="font-display font-light text-2xl leading-none">EN 1090-2</div>
                <div className="mt-2 font-mono text-[9.5px] uppercase tracking-[0.2em] text-white/70">AWS · TSE Standartları</div>
              </div>
            </div>
          </Reveal>
          <Reveal delay={150} className="lg:col-span-6 lg:pl-6">
            <SectionHeading eyebrow="Kurumsal" title="Çeliğin Hayat Bulduğu Yer İLKA" />
            <ul className="mt-9 space-y-px bg-brand-line border border-brand-line">
              {principles.map((p, i) => (
                <li key={i} className="bg-white px-6 py-4 flex items-start gap-4 text-[13.5px] text-brand-ink leading-relaxed">
                  <span className="font-mono text-[10px] text-brand-accent/60 mt-1">{String(i + 1).padStart(2, "0")}</span>
                  {p}
                </li>
              ))}
            </ul>
            <p className="mt-8 text-[14.5px] text-brand-muted leading-[1.85] font-light">
              Kendi branşlarında uzman mesai arkadaşlarımız, profesyonel çalışma anlayışı ile sürekli yanımızda olan tedarikçi firma ve
              çözüm ortaklarımız ve bizlerden desteğini esirgemeyen değerli işverenlerimiz ile ülke ekonomisine katkı sağlamak ana
              ilkemizdir.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Stats */}
      <section className="grain relative bg-brand-ink overflow-hidden" data-testid="about-stats">
        <div className="absolute inset-0 blueprint opacity-80" />
        <div className="glow pointer-events-none absolute -top-40 left-1/4 w-[560px] h-[560px] opacity-40" />
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/[0.08]">
          {stats.map((s, i) => (
            <div key={i} className="bg-brand-ink px-8 py-12 lg:py-16">
              <span className="font-mono text-[10px] tracking-[0.28em] text-white/25">0{i + 1}</span>
              <CountUp value={s.value} className="mt-4 block font-display font-light text-4xl lg:text-[2.8rem] leading-none text-white tabular-nums" />
              <div className="mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Applications quick links */}
      <section className="bg-brand-paper py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <Reveal>
            <SectionHeading eyebrow="Hizmetlerimiz" title="Uygulama Alanlarımız" className="mb-14" />
          </Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-brand-line border border-brand-line">
            {applications.map((a, i) => (
              <Link
                key={a.slug}
                to={`/uygulama/${a.slug}`}
                data-testid={`about-app-link-${a.slug}`}
                className="group bg-white hover:bg-brand-accent flex items-center justify-between gap-4 px-6 py-6 transition-colors duration-500"
              >
                <span className="flex items-center gap-4">
                  <span className="font-mono text-[10px] text-brand-accent/50 group-hover:text-white/50 transition-colors duration-300">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-display text-[15px] font-normal text-brand-ink group-hover:text-white transition-colors duration-300">
                    {a.title}
                  </span>
                </span>
                <ArrowUpRight className="w-4 h-4 text-brand-accent group-hover:text-white transition-[color,transform] duration-300 group-hover:rotate-45" />
              </Link>
            ))}
          </div>
        </div>
      </section>

      <QuoteBand />
    </div>
  );
}
